import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { ContactscreenCoreService } from './services/contactscreen.service';

import * as contactscreen from './store/contactscreen.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature('contactScreen', contactscreen.contactscreenReducer),
  ],
  providers: [ContactscreenCoreService],
})
export class ContactscreenModule {}
